import config from 'config';
import buildAuthToken from 'utils/build-auth-token';

const {
	HOST: { APIM_SUBSCRIPTION_KEY },
	HOST: { BASE_APIM_URL }
} = config;

export const API_ERROR_MESSAGE = 'Sorry, something went wrong.  Please try again later.';
export const API_LOAD_ERROR_MESSAGE = "Sorry, we can't load $token right now. Please wait a bit and try again.";
export const NO_CLIENT_SELECTION_MESSAGE = 'You must select a client.';
export const BANNER_ERROR_MESSAGE = 'Please correct the errors below to continue.';
export const UNAUTHENTICATED_ERROR_MESSAGE = 'Access denied. Please login with authenticated user. Redirecting to Login page.';
export const SOMETHING_WENT_WRONG = "Something went wrong, please wait and try again or contact DeveloperPortalSupport@paycor.com.";
export const CLIENTS_NOT_UNDER_SAME_COMPANY = "At this time you cannot activate multiple clients that are not in the same company.";

export let STANDARD_HEADERS = {
	Accept: 'application/json',
	'Content-Type': 'application/json',
	pragma: 'no-cache',
	'cache-control': 'no-cache'
};

let FORM_DATA_HEADERS = {
	Accept: 'application/json, text/javascript, */*',
	pragma: 'no-cache',
	'cache-control': 'no-cache'
};

let FORM_URLENCODED_DATA_HEADERS = {
	Accept: 'application/json, text/javascript, */*',
	'Content-Type': 'application/x-www-form-urlencoded',
	pragma: 'no-cache',
	'cache-control': 'no-cache'
};

export const METHODS = {
	GET: 'get',
	POST: 'post',
	PUT: 'put',
	DELETE: 'delete'
};

const defaultHeadersForType = (type = 'standard') => {
	if (type === 'form') {
		return FORM_DATA_HEADERS;
	} else if (type === 'form-urlencoded') {
		return FORM_URLENCODED_DATA_HEADERS;
	}
	return STANDARD_HEADERS;
};

export const HTTP_HEADERS = (type = 'standard') => {
	let _headers = defaultHeadersForType(type);
	_headers = Object.assign(_headers, {
		'Ocp-Apim-Subscription-Key': APIM_SUBSCRIPTION_KEY,
		authorization: `${buildAuthToken()}`
	});

	return {
		GET: {
			method: METHODS.GET,
			mode: 'cors',
			headers: _headers,
			credentials: 'include'
		},
		POST: {
			method: METHODS.POST,
			mode: 'cors',
			headers: _headers,
			credentials: 'include'
		},
		PUT: {
			method: METHODS.PUT,
			mode: 'cors',
			headers: _headers,
			credentials: 'include'
		},
		DELETE: {
			method: METHODS.DELETE,
			mode: 'cors',
			headers: _headers,
			credentials: 'include'
		}
	};
};

export const API_URL = {
	API: `/api`,
	AUTHENTICATION: `/authentication`,
	ACCOUNTS: `/accounts`,
	STS: `/sts/`,
	APP_ACTIVATION: '/appactivator',
	APP_CREATOR: '/appcreator',
	APIM_ROOT: (api) => {
		return process.env.NODE_ENV === 'production' ? `${BASE_APIM_URL}${api}` : api;
	}
};

export const APP_INFO = {
	APP_TYPE_STANDARD: 1,
	APP_TYPE_REPORTING: 2,
	APP_TYPE_DATAIMPORT: 3,
	APP_TYPE_LEGALENTITY: 4,
	APP_TYPE_EMPLOYEE: 5
};
